import { useState } from "react";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";
import { Panel, SelectField, Empty } from "@/components/Bits";
import { Field } from "@/components/Field";
import { useFetch, openPdf, BRL, thisMonth } from "@/lib/useFetch";

const Stat = ({ label, value, testId, dark }) => (
  <div className={`rounded-2xl border border-[#E2DDD3] p-4 ${dark ? "bg-[#1E4D2B] text-white" : "bg-white"}`} data-testid={testId}>
    <p className="text-[11px] font-bold uppercase tracking-wider opacity-80">{label}</p>
    <p className="font-display text-2xl font-extrabold mt-1">{BRL(value)}</p>
  </div>
);

const TecCard = ({ t }) => (
  <Panel title={t.nome || "—"} testId={`rel-tec-${t.tecnico_id}`}>
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 text-sm">
      {[["Comissões", t.total_comissoes], ["Bônus", t.total_bonus], ["Pago no mês", t.total_pago], ["Pendente do mês", t.pendente], ["A receber (geral)", t.a_receber_geral]].map(([l, v]) => (
        <div key={l}><p className="text-[11px] font-bold uppercase tracking-wider text-[#5C6B66]">{l}</p><p className="font-bold text-[#1E4D2B]">{BRL(v)}</p></div>
      ))}
    </div>
    <p className="text-xs text-[#5C6B66] mt-3">{t.comissoes.length} comissão(ões) · {t.bonus.length} bônus · {t.pagamentos.length} pagamento(s)</p>
  </Panel>
);

export const RelatorioComissoes = ({ equipe }) => {
  const [mes, setMes] = useState(thisMonth());
  const [tec, setTec] = useState("");
  const [busy, setBusy] = useState(false);
  const params = { mes, tecnico_id: tec || undefined };
  const { data } = useFetch(mes ? "/relatorios/comissoes" : null, params);
  const pdf = async () => {
    setBusy(true);
    const qs = new URLSearchParams({ mes, ...(tec ? { tecnico_id: tec } : {}) });
    try { await openPdf(`/relatorios/comissoes/pdf?${qs}`, `comissoes-${mes}.pdf`); } catch { toast.error("Falha ao gerar PDF"); }
    setBusy(false);
  };
  return (
    <div className="space-y-4" data-testid="rel-comissoes">
      <div className="grid sm:grid-cols-[200px_1fr_auto] gap-3 items-end">
        <Field label="Mês" id="rel-mes" type="month" value={mes} onChange={(e) => setMes(e.target.value)} data-testid="rel-mes" />
        <SelectField label="Técnico" id="rel-tec" placeholder="Todos" value={tec} onChange={(e) => setTec(e.target.value)}
          options={(equipe || []).map((u) => ({ value: u.user_id, label: u.name }))} data-testid="rel-tecnico" />
        <button onClick={pdf} disabled={busy || !mes} data-testid="rel-pdf-button"
          className="h-14 px-6 rounded-xl bg-[#C86D51] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#B05A40] disabled:opacity-60">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <FileDown className="h-5 w-5" />} Baixar PDF
        </button>
      </div>
      {data && <>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <Stat label="Total do mês" value={data.totais.total} dark testId="rel-total" />
          <Stat label="Comissões" value={data.totais.comissoes} testId="rel-comissoes-total" />
          <Stat label="Bônus" value={data.totais.bonus} testId="rel-bonus-total" />
          <Stat label="Pago no mês" value={data.totais.pago} testId="rel-pago-total" />
        </div>
        {data.tecnicos.length ? data.tecnicos.map((t) => <TecCard key={t.tecnico_id} t={t} />) : <Empty testId="rel-empty">Nada registrado neste mês.</Empty>}
      </>}
    </div>
  );
};
